import React from 'react';
import { withTranslation } from 'react-i18next';
import { ENUMS } from '../../../../utils/constants';
import { formatData, getUserNameToName } from '../../../../utils/util';

const LotItemReading = (props) => {
    return props.data ? (
        <li
            key={`${props.data.lotItemReadingId}`}
            className="collection-item avatar z-depth-1 s12"
            style={{ backgroundColor: 'white', color: 'black', display: 'block', paddingTop: '2px', paddingBottom: '2px' }}
        >
            <span
                className="circle f-2r"
                style={{
                    minWidth: '60px !important',
                    minHeight: '60px !important',
                    display: 'flex',
                    alignContent: 'center',
                    alignItems: 'center',
                    left: '15px'
                }}
            >
                {
                    props.data.lotItemReadingOriginId === ENUMS.eInventoryOriginCount.Drone.value ? (
                        <i className="mdi mdi-quadcopter" style={{ color: '#597dda' }} />
                    ) : (
                        <i className="mdi mdi-cellphone-android" style={{ color: '#597dda' }} />
                    )
                }
            </span>
            <div className="col s12 title" style={{ paddingLeft: '0' }}>
                <i className="mdi mdi-text-box-check-outline" style={{ color: '#597dda' }} /> <strong>{`${props.data.lotItemNumber}`}</strong>
            </div>
            <div className="col s12 subtitle crop-text-250" style={{ paddingLeft: '0' }}>
                <i className="mdi mdi-map-marker-radius-outline" style={{ color: '#597dda' }} /> {props.data.location}
            </div>
            <div className="row" style={{ marginBottom: '5px' }}>
                <div className="col s12">
                    <i className="mdi mdi-account-circle" style={{ color: '#597dda' }} /> <span style={{ fontSize: '0.8rem', fontFamily: 'Roboto' }}>{props.data.updateBy} - {getUserNameToName(props.usersFromElog, props.data.updateBy)}</span>
                </div>
                <div className="col s12">
                    <i className="mdi mdi-calendar-clock" style={{ color: '#597dda' }} /> <span style={{ fontSize: '0.8rem', fontFamily: 'Roboto' }}>{formatData(props.data.updateOn)}</span>
                </div>
                <div className="col s12 f-2r">
                    {
                        props.data.divergent ? (
                            <i className="mdi mdi-alert-circle-outline" style={{ color: 'red' }} />
                        ) : (
                            <i className="mdi mdi-checkbox-marked-circle-outline" style={{ color: '#4caf50' }} />
                        )
                    }
                    {
                        props.data.versionQuantity > 1 ? (
                            <i className="mdi mdi-numeric-2-box-outline" style={{ color: '#597dda' }} />
                        ) : (
                            <i className="mdi mdi-numeric-1-box-outline" style={{ color: '#597dda' }} />
                        )
                    }
                </div>
            </div>
        </li>
    ) : null;
};

export default withTranslation()(LotItemReading);